/** @typedef {{ code: string; name: string; dialCode: string }} CountryOption */

/** @type {CountryOption[]} */
export const COUNTRY_DIAL_OPTIONS = [
  { code: 'CD', name: 'RDC', dialCode: '+243' },
  { code: 'CG', name: 'Congo', dialCode: '+242' },
  { code: 'CM', name: 'Cameroun', dialCode: '+237' },
  { code: 'CI', name: "Côte d'Ivoire", dialCode: '+225' },
  { code: 'SN', name: 'Sénégal', dialCode: '+221' },
  { code: 'FR', name: 'France', dialCode: '+33' },
  { code: 'BE', name: 'Belgique', dialCode: '+32' },
  { code: 'US', name: 'États-Unis', dialCode: '+1' },
  { code: 'CA', name: 'Canada', dialCode: '+1' },
  { code: 'GB', name: 'Royaume-Uni', dialCode: '+44' },
];

export function flagImageUrl(countryCode) {
  return `https://flagcdn.com/24x18/${String(countryCode).toLowerCase()}.png`;
}

/**
 * @param {string} raw
 * @param {string} dialCode
 */
export function normalizePhoneInput(raw, dialCode) {
  const value = String(raw || '').trim();
  if (!value) return '';

  const compact = value.replace(/\s+/g, '');
  if (compact.startsWith('+')) {
    const digits = compact.slice(1).replace(/\D/g, '');
    return digits ? `+${digits}` : '';
  }
  if (compact.startsWith('00')) {
    const digits = compact.slice(2).replace(/\D/g, '');
    return digits ? `+${digits}` : '';
  }

  const digits = compact.replace(/\D/g, '');
  if (!digits) return '';
  let normalized = `${dialCode}${digits}`;
  // +2430XXXXXXXX → +243XXXXXXXX (numéro local RDC avec 0 initial)
  if (/^\+2430\d{9}$/.test(normalized)) {
    normalized = `+243${normalized.slice(5)}`;
  }
  return normalized;
}
